import CustomDatapointsPage from '../../../../components/customDatapoints/CustomDatapointsPage';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

import Icon from '../../../../assets/icon_datapoint_dark.svg?react';

import {READ_CUSTOM_DATAPOINT} from '../../../../modules/common/consts';

export default {
	relativePath: 'customDatapoints',
	label: {
		id: 'route.label.assets.detail.customDatapoints',
		defaultValue: 'Custom Datapoints'
	},
	iconSvg: Icon,
	component: CustomDatapointsPage,
	requiredAuthorities: [READ_CUSTOM_DATAPOINT],
	config: {
		sidebarIndex: 5
	}
} satisfies RouteConfig;
